import { Controller } from "@hotwired/stimulus"

// Drives the candidates filter form (#candidate-filters). Any control change
// (job select, min-score slider, sort select) re-submits the GET form via
// requestSubmit() so Turbo does a full re-render with the new query params —
// the same behavior the legacy page had, minus a hard reload.
//
// Status is a hidden field (statusTarget): the chips are type=button and call
// setStatus, which writes the chosen value then submits. This keeps the status
// filter intact when an UNRELATED control auto-submits (a plain submit-button
// chip would only contribute its value when it is itself the submitter).
export default class extends Controller {
  static targets = ["form", "scoreOutput", "status", "chip"]

  submit() {
    if (this.hasFormTarget) this.formTarget.requestSubmit()
  }

  updateScore(event) {
    if (this.hasScoreOutputTarget) this.scoreOutputTarget.textContent = `${event.target.value}%`
  }

  setStatus(event) {
    const chosen = event.currentTarget.dataset.status
    if (this.hasStatusTarget) this.statusTarget.value = chosen
    // The chips are toggle buttons in a single-select group, so pressing one
    // un-presses the rest. The server re-renders aria-pressed from
    // params[:filter_status] on the way back — that is the durable value; this
    // keeps it truthful in the frame between the click and that navigation, and
    // it is the only state a keyboard user gets if the submit is slow.
    this.chipTargets.forEach((chip) => {
      const on = chip.dataset.status === chosen
      chip.setAttribute("aria-pressed", String(on))
      chip.classList.toggle("is-on", on)
    })
    this.submit()
  }
}
